import React, { useState } from 'react';
import { Routes, Route } from "react-router-dom";
import { Context, UserContext, KpiContext } from '../context/context';
import NotificacionProvider from '../context/NotificacionContext';
import { privateRoutes, publicRoutes } from './RootPage/routes';
import ProtectedRoutes from '../components/ProtectedRoutes';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../themeProvider/selectThemeProvider';

export default function App() {

  const [context, setContext] = useState("true");
  const [user, setUser] = useState({ loggedIn: false });
  const [kpiContext, setKpiContext] = useState("none");

  return (
    <ThemeProvider theme={theme}>
      <NotificacionProvider>
        <Context.Provider value={[context, setContext]}>
          <UserContext.Provider value={{ user, setUser }}>
            <KpiContext.Provider value={[kpiContext, setKpiContext]} >
              <Routes>
                {publicRoutes.map(route => (
                  <Route {...route} key={route.path} />
                ))}
                <Route element={<ProtectedRoutes />}>
                  {privateRoutes.map(route => (
                    <Route {...route} key={route.path} />
                  ))}
                </Route>
              </Routes>
            </KpiContext.Provider>
          </UserContext.Provider>
        </Context.Provider>
        <Toaster />
      </NotificacionProvider>
    </ThemeProvider>
  );
}
